/*
 * MC · Cambio de imagen por swatch en cards de catálogo.
 *
 * Desktop (hover): pasar el cursor por la muestra cambia la imagen del
 * producto; al salir, vuelve a la default.
 * Mobile (touch): tocar la muestra deja la imagen pegada (sticky) y
 * marca el swatch como activo. Al tocar otra muestra cambia. La nav
 * del producto sigue funcionando al tocar la imagen o el cuerpo.
 *
 * Las imágenes se precargan con IntersectionObserver en cuanto la card
 * entra al viewport, así el primer hover/tap no espera la descarga.
 */
(function () {
  'use strict';

  var ATTR = 'data-mc-variant-image';
  var IMG_ATTR = 'data-mc-original-src';
  var SRCSET_ATTR = 'data-mc-original-srcset';
  var SIZES_ATTR = 'data-mc-original-sizes';
  var BOUND_FLAG = 'mcSwatchBound';
  var PRELOADED_FLAG = 'mcSwatchPreloaded';
  var SWATCH_SEL = '.mc-prod-card__swatch-overlay';

  var isTouch = window.matchMedia &&
    window.matchMedia('(hover: none) and (pointer: coarse)').matches;

  function getCardImg(swatch) {
    var card = swatch.closest('[data-mc-prod-card]');
    if (!card) return null;
    return card.querySelector('.mc-prod-card__img') || card.querySelector('img');
  }

  function stashOriginal(img) {
    if (img.dataset.mcStashed) return;
    img.dataset.mcStashed = '1';
    img.setAttribute(IMG_ATTR, img.getAttribute('src') || '');
    var ss = img.getAttribute('srcset');
    if (ss) img.setAttribute(SRCSET_ATTR, ss);
    var sz = img.getAttribute('sizes');
    if (sz) img.setAttribute(SIZES_ATTR, sz);
  }

  function applyImage(swatch) {
    var url = swatch.getAttribute(ATTR);
    if (!url) return;
    var img = getCardImg(swatch);
    if (!img) return;
    stashOriginal(img);
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src = url;
  }

  function resetImage(swatch) {
    var img = getCardImg(swatch);
    if (!img) return;
    var orig = img.getAttribute(IMG_ATTR);
    var origSS = img.getAttribute(SRCSET_ATTR);
    var origSz = img.getAttribute(SIZES_ATTR);
    if (orig) img.src = orig;
    if (origSS) img.setAttribute('srcset', origSS);
    if (origSz) img.setAttribute('sizes', origSz);
  }

  function preloadSwatch(swatch) {
    if (swatch.dataset[PRELOADED_FLAG]) return;
    var url = swatch.getAttribute(ATTR);
    if (!url) return;
    swatch.dataset[PRELOADED_FLAG] = '1';
    var pre = new Image();
    pre.decoding = 'async';
    pre.loading = 'eager';
    pre.src = url;
  }

  function preloadAllInCard(card) {
    var swatches = card.querySelectorAll(SWATCH_SEL + '[' + ATTR + ']');
    swatches.forEach(preloadSwatch);
  }

  function clearActiveInGroup(swatch) {
    var group = swatch.parentElement;
    if (!group) return;
    var actives = group.querySelectorAll(SWATCH_SEL + '.is-active');
    actives.forEach(function (s) { s.classList.remove('is-active'); });
  }

  function bindSwatch(swatch) {
    if (swatch.dataset[BOUND_FLAG]) return;
    swatch.dataset[BOUND_FLAG] = '1';

    if (isTouch) {
      swatch.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        var wasActive = swatch.classList.contains('is-active');
        clearActiveInGroup(swatch);
        if (wasActive) {
          resetImage(swatch);
        } else {
          swatch.classList.add('is-active');
          applyImage(swatch);
        }
      });
      return;
    }

    swatch.addEventListener('mouseenter', function () {
      applyImage(swatch);
    });

    swatch.addEventListener('mouseleave', function (e) {
      var related = e.relatedTarget;
      if (related && swatch.parentElement && swatch.parentElement.contains(related)) return;
      resetImage(swatch);
    });

    swatch.addEventListener('focus', function () { applyImage(swatch); });
    swatch.addEventListener('blur', function () { resetImage(swatch); });

    swatch.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      applyImage(swatch);
    });
  }

  function bindAndPreloadAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var swatches = scope.querySelectorAll(SWATCH_SEL);
    swatches.forEach(function (s) {
      if (!s.dataset[BOUND_FLAG]) bindSwatch(s);
    });
  }

  function setupViewportPreloader() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('[data-mc-prod-card]').forEach(preloadAllInCard);
      return null;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        preloadAllInCard(entry.target);
        io.unobserve(entry.target);
      });
    }, { rootMargin: '300px 0px' });
    document.querySelectorAll('[data-mc-prod-card]').forEach(function (card) {
      io.observe(card);
    });
    return io;
  }

  function init() {
    bindAndPreloadAll(document);
    var io = setupViewportPreloader();

    var mo = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches(SWATCH_SEL)) {
            bindSwatch(node);
            return;
          }
          if (node.querySelectorAll) {
            bindAndPreloadAll(node);
            if (io) {
              var cards = node.matches && node.matches('[data-mc-prod-card]')
                ? [node]
                : node.querySelectorAll('[data-mc-prod-card]');
              cards.forEach(function (c) { io.observe(c); });
            }
          }
        });
      });
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
